module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya_ekimae/nagoya_ekimae_sns_06-8d9b587d322751e7279662e26b4c1ece.jpg";